import {
    STATISTIC_FETCH_REQUEST,
    STATISTIC_FILTER_AUTHOR,
    STATISTIC_FILTER_RECIPIENT,
    STATISTIC_SORTING_DERECTION,
    STATISTIC_FILTER_RECIPIENT_TEAM
} from './constans';
import {Profile} from 'feedback-system/dto/IProfile';

export const getFeedbacksData = (periodId: number, user: Profile | null) => ({
    type: STATISTIC_FETCH_REQUEST,
    periodId,
    user
});

export const setFilterAuthor = (value: string) => ({
    type: STATISTIC_FILTER_AUTHOR,
    payload: {value}
});

export const setFilerRecipient = (value: string) => ({
    type: STATISTIC_FILTER_RECIPIENT,
    payload: {value}
});

export const setFilerRecipientTeam = (value: string) => ({
    type: STATISTIC_FILTER_RECIPIENT_TEAM,
    payload: {value}
});

export const setDerection = (derection: string) => ({
    type: STATISTIC_SORTING_DERECTION,
    payload: {derection}
});
